import { nextTick, ref } from 'vue';
import { normalizeHomeHash, scrollToHomeHash } from '@/utils/homeHash.js';

const pendingHash = ref('');
let ensureSectionsFn = null;

export function registerHomeSectionEnsurer(fn) {
  ensureSectionsFn = fn;
}

export function hasPendingHomeSectionScroll() {
  return !!pendingHash.value;
}

export function clearPendingHomeSectionScroll() {
  pendingHash.value = '';
}

export function useHomeSectionNav() {
  return { pendingHash };
}

async function waitForPaint() {
  await nextTick();
  await nextTick();
  await new Promise((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(resolve));
  });
}

/** 同步 URL hash，不触发 vue-router 导航 */
export function syncHashToUrl(hash) {
  const normalized = normalizeHomeHash(hash);
  if (!normalized) return;
  const nextUrl = `${window.location.pathname}${window.location.search}${normalized}`;
  const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  if (currentUrl !== nextUrl) {
    history.replaceState(history.state, '', nextUrl);
  }
}

/** 统一入口：同页滚动 / 跨页带 pending hash 跳转 */
export async function navigateToHomeSection(router, route, hash) {
  const normalized = normalizeHomeHash(hash);
  if (!normalized) return;

  if (route.name === 'home') {
    clearPendingHomeSectionScroll();
    ensureSectionsFn?.(normalized);
    await waitForPaint();
    await scrollToHomeHash(normalized, 'smooth');
    syncHashToUrl(normalized);
    return;
  }

  pendingHash.value = normalized;
  await router.push('/');
}

/** 跨页落地后由 HomeView 调用 */
export async function consumePendingHomeSectionScroll() {
  const hash = pendingHash.value;
  if (!hash) return;

  pendingHash.value = '';
  ensureSectionsFn?.(hash);
  await waitForPaint();
  await scrollToHomeHash(hash, 'auto');
  syncHashToUrl(hash);
}
